import { render, staticRenderFns } from "./AnswerQuestion.vue?vue&type=template&id=5b66126e&scoped=true"
import script from "./AnswerQuestion.vue?vue&type=script&lang=js"
export * from "./AnswerQuestion.vue?vue&type=script&lang=js"
import style0 from "./AnswerQuestion.vue?vue&type=style&index=0&id=5b66126e&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b66126e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b66126e')) {
      api.createRecord('5b66126e', component.options)
    } else {
      api.reload('5b66126e', component.options)
    }
    module.hot.accept("./AnswerQuestion.vue?vue&type=template&id=5b66126e&scoped=true", function () {
      api.rerender('5b66126e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/school/mentalHealth/StudentAnswer/components/AnswerQuestion.vue"
export default component.exports